import { atom } from "jotai";

export const alertAtom = atom<string | null>(null);
